<template>
  <v-snackbar
    v-model="show"
    :multi-line="false"
    :timeout="5000"
    :bottom="true"
    :left="true"
    :color="$store.state.interfaceSettings.notification.success ? 'success' : 'error'"
  >
    {{ $store.state.interfaceSettings.notification.message }}
    <v-btn color="white" text @click="show = false">x</v-btn>
  </v-snackbar>
</template>
<script>
export default {
  name: 'SnackBar',
  computed: {
    show: {
      get () {
        return this.$store.state.interfaceSettings.notification.show
      },
      set () {
        this.$store.commit('interfaceSettings/UNSET_notification')
      }
    }
  }
}
</script>
